import request from '@/utils/request'
import qs from 'qs'
export function xcLeadInfo(data) {
    return request({
        url: "api/xcLeadInfo",
        method: 'post',
        data
    })
}

export function xcLeadInfoNL(data) {
    return request({
        url: "cus/xcLeadInfo",
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/applyPage.js